import React, {
  forwardRef,
  useState,
  useMemo,
  useCallback,
  useRef,
} from "react";
import ToolsIntegrationsAPI from "restAPI/ToolsIntegrationAPI";
import { FieldTypes, parseSelectOptions } from "utils/formUtils";
import GenericMappingForm from "../GenericMappingForm";
import { isEmpty, uniqBy } from "lodash";
import message from "components/CustomMessage";

const IriusRiskMappingForm = forwardRef(function IriusRiskMappingForm(
 { disableProjectFields = false, ...props },
  ref
) {
  const [mappedProjectList] = useState(() => {
    //using mappedProjectList to preserve the selected project when API fails
    if (props.record) {
      const { projectId, projectName } = props.record;
      return { projects: [{ id: projectId, name: projectName }] };
    }
    return { projects: [] };
  });

  const projectRef = useRef({ projects: mappedProjectList.projects });

  const fetchProjects = useCallback(() => {
    const { promise, cancel } =
      ToolsIntegrationsAPI.getGenericProjectByToolName(props.toolName, {
        login_id: props.loginConfigId,
      });
    promise
      .then((response) => {
        const { projects } = response;
        if (mappedProjectList["projects"].length > 0 && !isEmpty(projects)) {
          response.projects = uniqBy(
            [...projects, ...mappedProjectList["projects"]],
            "id"
          );
        }

        projectRef.current["projects"] = response.projects;
      })
      .catch((err) => {
        message.error("Problem fetching projects");
      });

    return { promise, cancel };
  }, [props.loginConfigId, props.toolName, mappedProjectList]);

  const getExtraFieldsData = useCallback((config) => {
    const { projectId } = config;
    const project = projectRef.current.projects.find(p => p.id === projectId);
    const projectName = project?.name;
    const projectIdV2 = project?.otherProperties?.projectIdV2;
    return {
        projectId,
        projectName,
        ...(projectIdV2 && { projectIdV2 }),
        ...(config.discovery_config_id && {
          discovery_config_id: config.discovery_config_id,
        }),
    };
  }, []);

  const parseExtraFieldsDataFromResponse = useCallback((config) => {
    return { 
      projectId: config.projectId,
      //send the property received in config
      ...(config.discovery_config_id && { discovery_config_id: config.discovery_config_id })
    };
  }, []);

  const extraFields = useMemo(
    () => [
      {
        name: "projectId",
        colSpan: "12",
        type: FieldTypes.SELECT,
        label: "Project Name",
        required: true,
        disabled: disableProjectFields,
        props: {
          autoFocus: !disableProjectFields,
          api: fetchProjects,
          parseSelectOptions: (res) => parseSelectOptions(res.projects),
        },
      },
    ],
    [fetchProjects, disableProjectFields]
  );

  return (
    <GenericMappingForm
      ref={ref}
      getExtraFieldsData={getExtraFieldsData}
      parseExtraFieldsDataFromResponse={parseExtraFieldsDataFromResponse}
      extraFields={extraFields}
      {...props}
    />
  );
});

export default IriusRiskMappingForm;
